import { defineComponent, reactive, watch, ref, nextTick } from 'vue';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { LoginService } from '@/services/login.service';
import { useService } from '@kaokei/use-vue-service';
import VCode from '@/components/VCode.vue';
import ImageCode from '@/components/ImageCode.vue';
import { logger, phonePattern, imageCodePattern } from '@/utils';
import { useRoute } from 'vue-router';
import { debounce } from 'lodash-es';
export default defineComponent({
  name: 'GetAccountInfo',
  components: {
    VCode: VCode,
    ImageCode: ImageCode,
    EnvironmentOutlined: EnvironmentOutlined
  },
  setup: function () {
    var loginService = useService(LoginService);
    var route = useRoute();
    var showImgCode = ref(false);
    var formRef = ref();
    var formState = reactive({
      phone: '',
      imageCode: '',
      code: ''
    });
    var formRules = reactive({
      phone: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      }, {
        pattern: phonePattern,
        message: '手机号不正确',
        trigger: 'blur'
      }],
      imageCode: [{
        required: true,
        message: '请输入图片验证码',
        trigger: 'blur'
      }, {
        pattern: imageCodePattern,
        message: '图片验证码不正确',
        trigger: 'blur'
      }],
      code: [{
        required: true,
        message: '请输入短信验证码',
        trigger: 'blur'
      }]
    });
    var onSubmit = debounce(function () {
      if (!formRef.value) return;
      formRef.value.validate().then(function () {
        var id = route.params.id || '';
        return loginService.getLoginAccount({
          contestId: id,
          mobile: formState.phone,
          verifyCode: formState.code
        }).then(function (res) {
          loginService.accountInfo.username = res.userName;
          loginService.accountInfo.account = res.userId;
          loginService.accountInfo.pwd = res.password;
          loginService.toggleGetAccountVisible(false);
          nextTick(function () {
            loginService.toggleAccountInfoVisible(true);
          });
        });
      }).catch(function (e) {
        logger.debug('提交登录表单失败 => ', e);
      });
    }, 500);
    // 监听登录弹窗是否关闭
    watch(function () {
      return loginService.getAccountVisible;
    }, function (visible) {
      if (!visible) {
        formRef.value.resetFields();
      }
    });
    var onShowImgCode = function () {
      showImgCode.value = true;
    };
    return {
      labelCol: {
        span: 0
      },
      wrapperCol: {
        span: 24
      },
      formRef: formRef,
      formState: formState,
      formRules: formRules,
      onSubmit: onSubmit,
      loginService: loginService,
      onShowImgCode: onShowImgCode,
      showImgCode: showImgCode
    };
  }
});